module.exports = __webpack_public_path__ + "static/media/link-icon.74412cfd.svg";